"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[423],{

/***/ 4085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9198);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_datepicker__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5444);
/* harmony import */ var _styles_General_Input_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6493);
/* harmony import */ var _styles_General_Input_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_General_Input_module_css__WEBPACK_IMPORTED_MODULE_4__);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    &::placeholder {\n        font-size : 13px;\n        font-weight : 300\n    }\n    &:disabled {\n        opacity : 0.6;\n    }\n    &::before {\n        content: attr(placeholder);\n        position: absolute;\n        color: #999999;\n    }\n\n    &:focus::before,\n    &:valid::before {\n        content: "";\n    }\n\n    color-scheme: dark;\n'
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}





const StyledInput = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-9d07b8ba-0"
})(_templateObject());
function DatePicker(props) {
    const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    // FUNCTIONS
    const ExampleCustomInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, ref)=>/*#__PURE__*/ {
        let { value , onClick  } = param;
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "flex-col",
            children: [
                props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                    className: "inline-block mb-1 ".concat(props.labelProperties),
                    style: {
                        color: props.labelColor
                    },
                    children: [
                        " ",
                        props.label,
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    onClick: ()=>inputRef.current.focus(),
                    className: "flex bg-white justify-center items-center cursor-text ".concat(props.outerProperties),
                    style: {
                        background: props.background
                    },
                    children: [
                        props.prefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_styles_General_Input_module_css__WEBPACK_IMPORTED_MODULE_4___default().prefix),
                            children: props.prefix
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledInput, {
                            ref: inputRef,
                            className: "".concat((_styles_General_Input_module_css__WEBPACK_IMPORTED_MODULE_4___default().input), " focus:outline-0 ").concat(props.properties),
                            type: "text",
                            placeholder: props.placeholder,
                            style: {
                                background: props.background,
                                color: props.color
                            },
                            name: props.name,
                            defaultValue: value,
                            onFocus: onClick,
                            disabled: props.disabled,
                            onBlur: props.onBlur
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "suffix",
                            children: props.suffix
                        })
                    ]
                }),
                props.error && props.touched && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("small", {
                    className: "text-error",
                    children: [
                        " ",
                        props.error,
                        " "
                    ]
                })
            ]
        });
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((react_datepicker__WEBPACK_IMPORTED_MODULE_5___default()), {
            isClearable: true,
            selected: props.initialValue,
            onChange: props.onChange,
            showMonthDropdown: true,
            showYearDropdown: true,
            customInput: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ExampleCustomInput, {}),
            dateFormat: "yyyy-MM-dd",
            minDate: props.minimumDate
        })
    });
}
DatePicker.defaultProps = {
    placeholder: "",
    prefix: "",
    suffix: "",
    outerProperties: "",
    autoComplete: false,
    background: "white",
    color: "black",
    labelColor: "white",
    labelProperties: "",
    touched: false,
    error: null,
    disabled: false,
    minimumDate: null
};
/* harmony default export */ __webpack_exports__["Z"] = (DatePicker);


/***/ }),

/***/ 9403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_CoreSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1266);
/* harmony import */ var _LinearLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2573);




function FileInput(param) {
    let { multiple , children , uniqueID , uploadDirectly , disabled , storeDataType , name , error  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const handleFileChange = (event)=>{
        if (uploadDirectly) {
            const formdata = new FormData();
            for(var i = 0; i < event.target.files.length; i++)formdata.append("file", event.target.files[i]);
            dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_2__/* .uploadFile */ .cT)(formdata, storeDataType));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "block cursor-pointer",
                htmlFor: uniqueID,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinearLoader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                disabled: disabled,
                id: uniqueID,
                className: "hidden",
                type: "file",
                multiple: multiple,
                onChange: handleFileChange,
                name: name
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("small", {
                className: "display-block text-error",
                children: [
                    " ",
                    error,
                    " "
                ]
            })
        ]
    });
}
FileInput.defaultProps = {
    multiple: false,
    uploadDirectly: true,
    disabled: false,
    storeDataType: "replace",
    name: "",
    error: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (FileInput);


/***/ }),

/***/ 8164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Home_FAQs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/General/Input.tsx
var Input = __webpack_require__(348);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/General/Accordian.tsx


function Accordian(param) {
    let { data  } = param;
    const [showContent, setShowContent] = (0,react.useState)(false);
    const answers = data.answer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "expand-slide cursor-pointer py-5 mb-1 text-theme-black",
            onClick: ()=>setShowContent(!showContent),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "select-none flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-theme-dark-saffron text-md font-[500] lg:text-[20px] font-[400]",
                            children: [
                                " ",
                                data.question,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: showContent ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                                className: "w-5 h-5 p-1 bg rounded-full text-theme-dark-saffron",
                                style: {
                                    background: "rgba(57, 20, 0, 0.2)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fillRule: "evenodd",
                                    d: "M3.75 12a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z",
                                    clipRule: "evenodd"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                                className: "w-5 h-5 p-1 rounded-full text-theme-dark-saffron",
                                style: {
                                    background: "rgba(57, 20, 0, 0.2)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fillRule: "evenodd",
                                    d: "M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z",
                                    clipRule: "evenodd"
                                })
                            })
                        })
                    ]
                }),
                showContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[16px] mt-3 text-[#313037] font-[300]",
                    dangerouslySetInnerHTML: {
                        "__html": answers
                    }
                })
            ]
        })
    });
}
Accordian.defaultProps = {
    data: {}
};
/* harmony default export */ var General_Accordian = (Accordian);

;// CONCATENATED MODULE: ./src/constants/FAQs.ts
const Tabs = [
    "general",
    "financing",
    "logistics",
    "quality",
    "support"
];
const FAQs = [
    {
        question: "What is APIdrug.com?",
        answer: "\n            We are a Global platform for Pharma ingredients sourcing headquartered in Singapore. \n            It is a go to destination for pharma manufacturers and API manufacturers across the globe to streamline their \n            existing sourcing requirements and improving the accessibility and the availability of APIs/pharma ingredients \n            through an integrated tech platform. APIdrug.com has global presence across Singapore/SEA, India, China, MEA, \n            and European markets.\n        ",
        category: "general"
    },
    {
        question: "How does APIdrug.com help me as a buyer?",
        answer: "\n            <div>\n                <ul>\n                    <li>Best pricing discovery</li>\n                    <p> \n                        - Bringing together the entire API & Pharma Ingredients value chain to make it available at the best price. By providing access to a wider seller base, we ensure the best pricing \n                    </p>\n                </ul>\n                \n                <ul>\n                    <li>Quality adherence </li>\n                    <p> \n                        - The suppliers are verified, reliable and meet world-class quality standards such as FDA, EMA, TGA etc. Accredited global agencies validate sellers, certifications, quality checks and process standards. \n                    </p>\n                </ul>\n                <ul>\n                    <li> Access to financing options  </li>\n                    <p> \n                        - We offer supply chain financing options to make procurement easy and convenient. We have global tie ups with banks and NBFCs. \n                    </p>\n                </ul>\n                <ul>\n                    <li> On demand availability  </li>\n                    <p> \n                        - Having many manufacturers on the platform, provides consistent access to inventory. \n                    </p>\n                </ul>\n            </div>\n        ",
        category: "general"
    },
    {
        question: "Which are the products listed on APIdrug.com?",
        answer: "\n            Key Starting Material (KSM) |\n            Intermediates |\n            APIs |\n            Excipients |\n            Nutraceuticals \n        ",
        category: "general"
    },
    {
        question: "What is the cost of signing up on the platform?",
        answer: "As an introductory offer, the platform is free for both buyers and sellers to register",
        category: "general"
    },
    {
        question: "How does APIdrug.com make money?",
        answer: "We charge a fee on each transaction done on the platform",
        category: "general"
    },
    {
        question: "Does APIdrug.com provide supplier certificates?",
        answer: "Yes, all the suppliers onboard have their certificated uploaded on the platform. These certificates are verified and authenticated by international certification agencies",
        category: "quality"
    },
    {
        question: "Can a trader list his products on the platform?",
        answer: "\n            Yes, as a trader you must provide trader-related documents and quality documents from each \n            manufacturer\n        ",
        category: "general"
    },
    {
        question: "What happens when I place a request for quotation?",
        answer: "\n            If all the necessary details about your company and business case are provided on the platform, you should \n            expect to get a commercial offer from the manufacturer within 3-15 business days\n        ",
        category: ""
    },
    {
        question: "What happens once I accept an offer?",
        answer: "\n            <h1>\n                a. We send you a term sheet confirmation agreement for your signature as your commitment to \n                progress and sign CDA with the manufacturer\n            </h1> \n            <h1>\n                b. You make a dossier audit, if necessary (Read how APIdrug.com can help)\n            </h1> \n            <h1>\n                c. Agree on the commercial contract (based on the signed term sheet)\n            </h1> \n            <h1>\n                d. Agree on the logistics, financial and insurance terms and conditions.\n            </h1> \n            <h1>\n                e. Ship the product to the buyer based on agreed terms \n            </h1> \n        ",
        category: "general"
    },
    {
        question: "How much does it cost to place an order?",
        answer: "\n            Placing an order for a buyer is free of any charge\n        ",
        category: "general"
    },
    {
        question: "What documents do I need to provide to register?",
        answer: '\n            <p>- While registering on the platform, we require basic information to ascentain if you are a buyer or a seller.</p>\n            <p>- While transacting, we will require the following documents: </p>\n\n            <p> i. For Buyers </p>\n            <p style="margin-left : 10px"> 1. Registration certifications  </p>\n            <p  style="margin-left : 10px"> 2. Licenses (GMP, USFDA, EMA etc) </p>\n\n            <p> ii. For sellers  </p>\n            <p style="margin-left : 10px"> 1. Registration certifications  </p>\n            <p  style="margin-left : 10px"> 2. Licenses (GMP, USFDA, EMA etc) </p>\n            <p  style="margin-left : 10px"> 3. Manufacturing facility certificates & licenses for a material (API, KSM, etc.)  </p>\n\n            <p> - Seller business/company-related certificates & licenses </p>\n        ',
        category: "general"
    },
    {
        question: "What are shipping terms?",
        answer: "\n            Varies for each transaction. For example, ex-works, FOB or CIF. Fulfillment might be done by the seller or \n            3rd party logistics partner or using APIdrug’s own extensive delivery network\n        ",
        category: "logistics"
    },
    {
        question: "How should I reach out if I have any further questions?",
        answer: "\n            You can email us at support@apidrug.com OR call on +91-8655735634\n        ",
        category: "support"
    },
    {
        question: "Are there any restrictions on geography?",
        answer: "\n            APIdrug.com is a global platform with transactions happening cross border in line with local and international regulations\n        ",
        category: "general"
    },
    {
        question: "Can APIdrug.com help me with financing options?",
        answer: "\n            <h1>\n                - Yes, as a platform we have tied up with multiple MNC banks and NBFCs to ensure that you get access to financial instruments such as: \n            </h1> \n            <h1>\n                a. Revolving credit\n            </h1> \n            <h1>\n                b. EMI based finance\n            </h1> \n            <h1>\n                c. Invoice discounting & supply chain financing\n            </h1> \n            <h1>\n                c. Invoice discounting & supply chain financing\n            </h1> \n            <h1>\n                You can email us at support@apidrug.com OR call on +91-8655735634 to discuss further\n            </h1> \n        ",
        category: "financing"
    }
];
/* harmony default export */ var constants_FAQs = (FAQs);

;// CONCATENATED MODULE: ./src/components/Home/FAQs.tsx






function FAQsSection(props, ref) {
    const [searchString, setSearchString] = (0,react.useState)("");
    const [currentTab, setCurrentTab] = (0,react.useState)(()=>"general");
    const [dataList, setDataList] = (0,react.useState)(()=>{
        return constants_FAQs.filter((FAQ)=>FAQ.category === currentTab);
    });
    const searchQuestions = (event)=>{
        setSearchString(event.target.value);
        let results = [];
        constants_FAQs.forEach((data)=>{
            const lowerStringQuestion = data.question.toLowerCase();
            if (lowerStringQuestion.includes(event.target.value.toLowerCase())) {
                results = [
                    ...results,
                    ...[
                        data
                    ]
                ];
            }
        });
        setDataList(results);
    };
    const filterByCategory = (tab)=>{
        setDataList(()=>{
            return constants_FAQs.filter((FAQ)=>FAQ.category === tab);
        });
        setCurrentTab(()=>tab);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "FAQ-section",
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col flex-col-reverse text-theme-black lg:flex-row lg:justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex overflow-x-auto mt-4 lg:mt-0 lg:w-[60%]",
                        children: Tabs.map((tab)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "\n                                    cursor-pointer\n                                    text-[20px]\n                                    capitalize \n                                    mr-4 \n                                    pb-4 \n                                    pt-2 \n                                    px-2\n                                    lg:px-4\n                                    ".concat(tab === currentTab && "border-t-[3px] border-theme-orange", "\n                                    ").concat(tab === currentTab ? "text-theme-orange" : "text-theme-dark-saffron", "\n                                    "),
                                style: {
                                    background: tab === currentTab ? "rgba(229, 233, 241, 0.4)" : "none"
                                },
                                onClick: ()=>filterByCategory(tab),
                                children: tab
                            }, tab))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:w-[30%] lg:mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            placeholder: "Have questions? We're here to help",
                            outerProperties: "border py-2 rounded",
                            suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                                className: "w-7 h-7 text-[gray] mx-3 border-l pl-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fillRule: "evenodd",
                                    d: "M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z",
                                    clipRule: "evenodd"
                                })
                            }),
                            value: searchString,
                            onChange: searchQuestions
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-3 py-3 lg:px-[20px] h-[430px] overflow-y-auto",
                style: {
                    background: "rgba(229, 233, 241, 0.4)"
                },
                children: dataList.map((data, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(General_Accordian, {
                            data: data
                        })
                    }, index))
            }),
            dataList.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-[gray] text-center",
                children: "No Results!"
            })
        ]
    });
}
/* harmony default export */ var Home_FAQs = (/*#__PURE__*/(0,react.forwardRef)(FAQsSection));


/***/ })

}]);